import {Injectable} from '@angular/core';
import {CrystalclearBackUrl} from '../config/crystalclear-back-url';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {ToastService} from '../toast-service';
import {ApiValidation} from "../../model/api/api-validation";
import {TableRecordResult} from "../../model/api/table-record-result";
import {CommonCrudService} from "../common/common-crud.service";
import {ReportProfile} from "../../model/archive/report-profile";
import {FieldRequest} from "../../model/api/field-request";
import {FieldResult} from "../../model/api/field-result";
import {ReportTemplate} from "../../model/archive/report-template";
import {CrystalclearCommonBackUrl} from "../config/crystalclear-common-back-url";
import {BatchUpdateRequest} from "../../model/api/batch-update-request";
import {ProfileFieldResult} from "../../model/archive/profile-field-result";
import {SimpleRequest} from "../../model/api/simple-request";

@Injectable({
  providedIn: 'root'
})
export class ProfileAbsService extends CommonCrudService<ReportProfile> {

  urlConfDownloadAsync: CrystalclearBackUrl.UrlConf<ApiValidation<string>>;
  urlConfDownloadForProfileAsync: CrystalclearBackUrl.UrlConf<ApiValidation<string>>;
  urlConfExecuteAsync: CrystalclearBackUrl.UrlConf<ApiValidation<string[]>>;
  urlConfExportTemplatesForm: CrystalclearBackUrl.UrlConf<FieldResult<ReportTemplate>>;
  urlConfExportTemplatesProfile: CrystalclearBackUrl.UrlConf<FieldResult<ReportTemplate>>;
  urlConfProfileFieldsForm: CrystalclearBackUrl.UrlConf<ProfileFieldResult>;
  urlConfMailTemplates: CrystalclearBackUrl.UrlConf<FieldResult<any>>;
  urlConfFileLocations: CrystalclearBackUrl.UrlConf<FieldResult<any>>;
  urlBatchUpdate: CrystalclearBackUrl.UrlConf<ApiValidation<any>>;

  constructor(http: HttpClient,
              toastService: ToastService,
              urlConfList: CrystalclearBackUrl.UrlConf<TableRecordResult<ReportProfile>>,
              urlConfSave: CrystalclearBackUrl.UrlConf<ApiValidation<ReportProfile>>,
              urlConfDelete: CrystalclearBackUrl.UrlConf<ApiValidation<ReportProfile>>,
              urlConfDownloadAsync: CrystalclearBackUrl.UrlConf<ApiValidation<string>>,
              urlConfDownloadForProfileAsync: CrystalclearBackUrl.UrlConf<ApiValidation<string>>,
              urlConfExecuteAsync: CrystalclearBackUrl.UrlConf<ApiValidation<any>>,
              urlConfExportTemplatesForm: CrystalclearBackUrl.UrlConf<FieldResult<ReportTemplate>>,
              urlConfExportTemplatesProfile: CrystalclearBackUrl.UrlConf<FieldResult<ReportTemplate>>,
              urlConfProfileFieldsForm: CrystalclearBackUrl.UrlConf<ProfileFieldResult>,
              urlConfMailTemplates: CrystalclearBackUrl.UrlConf<FieldResult<any>>,
              urlConfFileLocations: CrystalclearBackUrl.UrlConf<FieldResult<any>>,
              urlBatchUpdate: CrystalclearBackUrl.UrlConf<ApiValidation<any>>) {
    super(http,
      toastService,
      urlConfList,
      urlConfSave,
      urlConfDelete);
    this.urlConfDownloadAsync = urlConfDownloadAsync;
    this.urlConfDownloadForProfileAsync = urlConfDownloadForProfileAsync;
    this.urlConfExecuteAsync = urlConfExecuteAsync;
    this.urlConfExportTemplatesForm = urlConfExportTemplatesForm;
    this.urlConfExportTemplatesProfile = urlConfExportTemplatesProfile;
    this.urlConfProfileFieldsForm = urlConfProfileFieldsForm;
    this.urlConfMailTemplates = urlConfMailTemplates;
    this.urlConfFileLocations = urlConfFileLocations;
    this.urlBatchUpdate = urlBatchUpdate;
  }

  public saveBatch(request: BatchUpdateRequest<ReportProfile>): Observable<ApiValidation<any>> {
    return this.post(this.urlBatchUpdate, request);
  }

  public downloadAsync(origin: String, profileName: string): Observable<ApiValidation<string>> {
    return this.post(this.urlConfDownloadAsync, new SimpleRequest(profileName), {origin: origin.toString()});
  }

  public downloadForProfileAsync(origin: String, profile: ReportProfile): Observable<ApiValidation<string>> {
    return this.post(this.urlConfDownloadForProfileAsync, profile, {origin: origin.toString()});
  }

  public executeAsync(origin: String, profileNames: string[]): Observable<ApiValidation<string[]>> {
    return this.post(this.urlConfExecuteAsync, profileNames, {origin: origin.toString()});
  }

  public getExportTemplatesForm(request: FieldRequest): Observable<FieldResult<ReportTemplate>> {
    return this.post(this.urlConfExportTemplatesForm, request);
  }

  public getExportTemplatesProfile(request: FieldRequest): Observable<FieldResult<ReportTemplate>> {
    return this.post(this.urlConfExportTemplatesProfile, request);
  }

  public getProfileFieldsForm(request: FieldRequest): Observable<ProfileFieldResult> {
    return this.post(this.urlConfProfileFieldsForm, request);
  }

  public getMailTemplates(request: FieldRequest): Observable<FieldResult<any>> {
    return this.post(this.urlConfMailTemplates, request);
  }

  public getFileLocations(request: FieldRequest): Observable<FieldResult<any>> {
    return this.post(this.urlConfFileLocations, request);
  }

}
